<template>
  <div class="chat-input">
    <input
      v-model="text"
      class="ai-input"
      :placeholder="placeholder"
      :disabled="disabled"
      @keyup.enter="send"
    >
    <button class="btn" :disabled="disabled || !text.trim()" @click="send">{{ buttonLabel }}</button>
  </div>
</template>

<script>
export default {
  name: 'ChatInput',
  props: {
    placeholder: { type: String, default: '输入内容…' },
    buttonLabel: { type: String, default: '发送' },
    disabled: Boolean,
  },
  data: () => ({ text: '' }),
  methods: {
    send() {
      const t = this.text.trim();
      if (!t || this.disabled) return;
      this.$emit('send', t);
      this.text = '';
    },
  },
};
</script>

<style scoped>
.chat-input { display: flex; gap: 10px; margin-top: 12px; }
</style>
